import { Action } from '@ngrx/store';
import { ProfileUpdate } from '../../../shared/models/profile';
import { IResidentProfileCommon } from './resident-profile.interfaces';

export enum ResidentProfileActionTypes {
  LOAD_RESIDENT_PROFILE = '[Resident Profile] Load Resident Profile',
  LOAD_RESIDENT_PROFILE_SUCCESS = '[Resident Profile] Load Resident Profile Success',
  UPDATE_RESIDENT_PROFILE_UNIT_ID = '[Resident Profile] Update Resident Profile Unit Id',
  LOAD_RESIDENT_PROFILE_FAILURE = '[Resident Profile] Load Resident Profile Failure',
  SET_RESIDENT_PROFILE_ID = '[Resident Profile] Set Resident Profile Id',
  SET_RESIDENT_ROLE_ID = '[Resident Profile] Set Resident Role Id',
  UPDATE_RESIDENT_PROFILE = '[Resident Profile] Update Resident Profile',
  UPDATE_RESIDENT_PROFILE_SUCCESS = '[Resident Profile] Update Resident Profile Success',
  UPDATE_RESIDENT_PROFILE_FAILURE = '[Resident Profile] Update Resident Profile Failure',
  REMOVE_ALL_PROFILES = '[Resident Profile] Remove All Profiles',
  CHANGE_PROFILE = '[Resident Profile] Change Profile',
}

export class LoadResidentProfile implements Action {
  readonly type = ResidentProfileActionTypes.LOAD_RESIDENT_PROFILE;
  constructor() {}
}

export class LoadResidentProfileSuccess implements Action {
  readonly type = ResidentProfileActionTypes.LOAD_RESIDENT_PROFILE_SUCCESS;
  constructor(public payload: IResidentProfileCommon) {}
}

export class UpdateResidentProfileUnitId implements Action {
  readonly type = ResidentProfileActionTypes.UPDATE_RESIDENT_PROFILE_UNIT_ID;
  constructor(public payload: number, public profileId: number) {}
}

export class LoadResidentProfileFailure implements Action {
  readonly type = ResidentProfileActionTypes.LOAD_RESIDENT_PROFILE_FAILURE;
  constructor(public payload: string) {}
}

export class SetCurrentResidentProfileId implements Action {
  readonly type = ResidentProfileActionTypes.SET_RESIDENT_PROFILE_ID;
  constructor(public payload: number) {}
}
export class SetCurrentResidentRoleId implements Action {
  readonly type = ResidentProfileActionTypes.SET_RESIDENT_ROLE_ID;
  constructor(public payload: number) {}
}

export class RemoveAllProfiles implements Action {
  readonly type = ResidentProfileActionTypes.REMOVE_ALL_PROFILES;
}

export class UpdateResidentProfile implements Action {
  readonly type = ResidentProfileActionTypes.UPDATE_RESIDENT_PROFILE;
  constructor(public payload: ProfileUpdate) {}
}

export class UpdateResidentProfileSuccess implements Action {
  readonly type = ResidentProfileActionTypes.UPDATE_RESIDENT_PROFILE_SUCCESS;
  constructor(public payload: { profile: ProfileUpdate; image: string }) {}
}

export class UpdateResidentProfileFailure implements Action {
  readonly type = ResidentProfileActionTypes.UPDATE_RESIDENT_PROFILE_FAILURE;
  constructor(public payload: string) {}
}

export class ChangeProfile implements Action {
  readonly type = ResidentProfileActionTypes.CHANGE_PROFILE;
  constructor(public profileId: number, public unitId: number) {}
}

export type ResidentProfileActions =
  | LoadResidentProfile
  | LoadResidentProfileSuccess
  | LoadResidentProfileFailure
  | RemoveAllProfiles
  | SetCurrentResidentProfileId
  | UpdateResidentProfileFailure
  | UpdateResidentProfileSuccess
  | UpdateResidentProfile
  | SetCurrentResidentRoleId
  | UpdateResidentProfileUnitId
  | ChangeProfile;
